import React, { useState } from 'react';
import { BsBookmark, BsX } from 'react-icons/bs';
import { AiOutlineClockCircle } from 'react-icons/ai';

const Bookmarks = ({ bookmarks = [], duration = 0, onSeek, onDelete }) => {
  const [hoveredBookmark, setHoveredBookmark] = useState(null);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="absolute bottom-24 left-0 right-0 px-8">
      {/* Timeline bar */}
      <div className="relative w-full h-1 bg-gray-600/30 rounded-full mb-4">
        {/* Bookmark markers on timeline */}
        {bookmarks.map((bookmark, index) => {
          const position = (bookmark.time / duration) * 100;
          return (
            <div
              key={index}
              className="absolute top-1/2 -translate-y-1/2"
              style={{ left: `${position}%` }}
            >
              <div
                className="relative group"
                onMouseEnter={() => setHoveredBookmark(bookmark)}
                onMouseLeave={() => setHoveredBookmark(null)}
              >
                <div className="w-3 h-3 bg-blue-500 rounded-full hover:scale-150 transition-transform cursor-pointer"
                  onClick={() => onSeek(bookmark.time)}
                />
              </div>
            </div>
          );
        })}
      </div>

      {/* Bookmarks list */}
      <div className="flex gap-4 overflow-x-auto pb-2 hide-scrollbar">
        {bookmarks.map((bookmark, index) => (
          <div
            key={index}
            className={`flex items-center gap-2 px-4 py-2 bg-gray-800/80 rounded-lg transition-all duration-200
              ${hoveredBookmark === bookmark ? 'scale-105 bg-gray-700/80' : ''}
              hover:bg-gray-700/80 cursor-pointer group`}
            onMouseEnter={() => setHoveredBookmark(bookmark)}
            onMouseLeave={() => setHoveredBookmark(null)}
            onClick={() => onSeek(bookmark.time)}
          >
            <BsBookmark className="w-4 h-4 text-blue-400" />
            <span className="text-white/90 font-medium">
              {bookmark.description || `Bookmark ${index + 1}`}
            </span>
            <div className="flex items-center gap-1 text-gray-400">
              <AiOutlineClockCircle className="w-3 h-3" />
              <span className="text-sm">{formatTime(bookmark.time)}</span>
            </div>
            <button
              className="opacity-0 group-hover:opacity-100 transition-opacity ml-2 hover:text-red-400"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(index);
              }}
            >
              <BsX className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Bookmarks;